<div [ngClass]="_containerClass">
  <button
    (click)="onClick.emit()"
    [disabled]="isDisabled"
    [ngClass]="_buttonClasses"
    mat-button
    type="{{ type }}"
  >
    <ng-content />
  </button>
</div>
